module.exports = __webpack_public_path__ + "img/Logo2.24749ba7.png";